import { Link } from "react-router-dom";
import { ORG } from "../lib/seo";

/**
 * Small disambiguation block placed at the bottom of every content page.
 * Tells LLMs (and human readers) exactly what CFO Grade is, when this page
 * was last reviewed, and who maintains it. Standard E-E-A-T pattern.
 */
export default function EntityFooter({ reviewedAt = "February 15, 2026" }) {
  return (
    <aside
      className="mt-20 border-t border-[#E5E0D8] pt-8"
      data-testid="entity-footer"
    >
      <p className="text-[11px] uppercase tracking-[0.22em] text-[#5C665D]">
        About this page
      </p>
      <p className="text-sm text-[#1A1A1A] leading-relaxed mt-3 max-w-2xl">
        <span className="font-medium text-[#1F382E]">{ORG.name}</span> is a free
        financial health analyzer for small and mid-sized businesses. It computes
        24+ ratios (EBITDA, DSCR, margins, working capital), assigns a letter
        grade A+ to F, and benchmarks against your industry and region.
      </p>
      <p className="text-xs text-[#5C665D] mt-3 leading-relaxed">
        Reviewed by the CFO Grade Research Team · Last reviewed {reviewedAt} ·{" "}
        <Link to="/learn" className="underline underline-offset-2 hover:text-[#1F382E]">
          Methodology
        </Link>
      </p>
    </aside>
  );
}
